import { Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ToolManagerDto, ToolManagerRole, ToolManagerRoles } from '../../api/models/ToolManagerDto';

interface AdminToolManagersGridProps {
    members: ToolManagerDto[];
    loading: boolean;
    saving: boolean;
    onRemoveMember: (member: ToolManagerDto) => void;
}

const AdminToolManagersGrid = ({
    members,
    loading,
    saving,
    onRemoveMember,
}: AdminToolManagersGridProps): JSX.Element => {
    const columns: GridColDef[] = [
        {
            field: 'memberName',
            headerName: 'Name',
            flex: 1,
        },
        {
            field: 'memberEmail',
            headerName: 'Email',
            flex: 1,
        },
        {
            field: 'role',
            headerName: 'Role',
            flex: 0.7,
            valueGetter: (params) =>
                ToolManagerRoles[params.value as ToolManagerRole] ?? params.value,
        },
        {
            field: 'addedOn',
            headerName: 'Added On',
            flex: 0.7,
            renderCell: (params) => {
                return params.value ? new Date(params.value as string).toLocaleDateString() : '-';
            },
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => {
                const member = params.row as ToolManagerDto;
                return (
                    <IconButton
                        onClick={() => onRemoveMember(member)}
                        disabled={saving}
                        color='error'
                        size='small'
                    >
                        <Delete />
                    </IconButton>
                );
            },
        },
    ];

    const rows = members.map((member) => ({
        id: `${member.memberId}-${member.role}`,
        ...member,
    }));

    return (
        <DataGrid
            columns={columns}
            rows={rows}
            loading={loading || saving}
            autoHeight
            disableSelectionOnClick
        />
    );
};

export default AdminToolManagersGrid;
